export const teamFunctionalAreas = [
    { id: '1', name: 'Leadership', description: 'Secondary Leader manages the team in Main Leader\'s absence' },
    { id: '2', name: 'Treasury', description: 'Manages Financial' },
    { id: '3', name: 'Membership Management', description: 'Manages Membership' },
    { id: '4', name: 'Prayer Meetings Coordinator', description: 'Coordinates Prayer Meetings' },
    { id: '5', name: 'Emergency Response', description: 'Emergency situations and crisis management' },
    { id: '6', name: 'Facilities Management', description: 'Building and facility operations' },
    { id: '7', name: 'Missionary', description: 'Missionary Works' },
]